import { HStack, Spinner, useColorModeValue } from '@ramp/components';
import React from 'react';

/**
 * Full-screen loading indicator shown while the app boots or a lazy route
 * chunk resolves. Uses the Chakra `Spinner` (brand color) so it renders
 * immediately without depending on a remote logo, and visually matches the
 * inline spinner in index.html — keeping the whole loading phase continuous
 * (no black/grey gap) even when iOS Safari throttles the render.
 */
const PageLoader: React.FC = () => (
  <HStack w="100vw" h="100vh" alignItems="center" justifyContent="center" bg={useColorModeValue('white', 'gray.900')}>
    <Spinner color="brand.500" size="xl" thickness="4px" speed="0.8s" />
  </HStack>
);

export default PageLoader;
